export default "__VITE_ASSET__76c10497__"